/**
 * Диалоги подтверждения.
 *
 * Асинхронный интерфейс намеренно: window.confirm блокирует поток
 * и на мобильном выглядит чужеродно, а нативный диалог и будущая
 * собственная модалка асинхронны по природе. Экраны, написанные
 * под Promise, переживут замену реализации без правок.
 *
 * @returns {Promise<boolean>}
 */
export async function confirm(message) {
  return globalThis.confirm(message)
}

/**
 * Запрос строки у пользователя.
 * @returns {Promise<string|null>} null — пользователь отменил ввод
 */
export async function prompt(message, defaultValue = '') {
  return globalThis.prompt(message, defaultValue)
}
